// Client HTTP : en-tête anti-CSRF, erreurs typées en français, détection hors connexion.
export class ErreurApi extends Error {
  constructor(public status: number, public code: string, message: string, public details?: unknown) { super(message); }
}

async function requete<T>(methode: string, url: string, corps?: unknown, options: { formData?: FormData; signal?: AbortSignal } = {}): Promise<T> {
  let r: Response;
  try {
    r = await fetch(url, {
      method: methode,
      credentials: 'same-origin',
      signal: options.signal,
      headers: {
        ...(methode !== 'GET' ? { 'X-Trame': '1' } : {}),
        ...(corps !== undefined && !options.formData ? { 'Content-Type': 'application/json' } : {}),
      },
      body: options.formData ?? (corps !== undefined ? JSON.stringify(corps) : undefined),
    });
  } catch (e: any) {
    if (e?.name === 'AbortError') throw e;
    throw new ErreurApi(0, 'hors_connexion', navigator.onLine
      ? 'Le serveur ne répond pas. Vos saisies locales sont conservées ; réessayez dans un instant.'
      : 'Vous êtes hors connexion. Les fonctions qui demandent le serveur reprendront au retour du réseau.');
  }
  if (r.status === 204) return undefined as T;
  const type = r.headers.get('content-type') ?? '';
  const donnees = type.includes('application/json') ? await r.json() : await r.text();
  if (!r.ok) {
    const e = (donnees as any)?.erreur;
    throw new ErreurApi(r.status, e?.code ?? 'erreur', e?.message ?? `Erreur ${r.status}`, e?.details);
  }
  return donnees as T;
}

export const api = {
  get: <T>(url: string, signal?: AbortSignal) => requete<T>('GET', url, undefined, { signal }),
  post: <T>(url: string, corps?: unknown) => requete<T>('POST', url, corps ?? {}),
  put: <T>(url: string, corps?: unknown) => requete<T>('PUT', url, corps ?? {}),
  patch: <T>(url: string, corps?: unknown) => requete<T>('PATCH', url, corps ?? {}),
  del: <T>(url: string) => requete<T>('DELETE', url),
  envoyer: <T>(url: string, formData: FormData) => requete<T>('POST', url, undefined, { formData }),
};

export function messageErreur(e: unknown) {
  if (e instanceof ErreurApi) return e.message;
  return 'Une erreur inattendue est survenue.';
}
